import { useQuery } from 'react-apollo';

import useAuthenticated from '../../../../hooks/useAuthenticated';
import { MeQuery } from '../../../../graphql/queries/account';
import { EventAddonItems } from '../../../../graphql/queries/events';

const useWaldoficationFeatureUpsell = () => {
  const authenticated = useAuthenticated();

  const { data: { me: account } = {}, loading: loadingAccount } = useQuery(
    MeQuery,
    {
      skip: !authenticated,
    },
  );
  const { data: { eventAddonItems } = {}, loading: loadingAddons } = useQuery(
    EventAddonItems,
  );

  return {
    account,
    eventAddonItems,
    loading: loadingAccount || loadingAddons,
  };
};

export default useWaldoficationFeatureUpsell;
